$(document).ready(function () {
  // image with banner v2 slider
 $(".image-with-banner-text-main.mobile").slick({
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  adaptiveHeight: false,
  centerMode: true,
  centerPadding: "90px",
  appendDots: $('.for_slide-button'), // 👈 move dots here
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        appendDots: $('.for_slide-button'),
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        appendDots: $('.for_slide-button'),
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerPadding: "40px",
        appendDots: $('.for_slide-button'),
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerPadding: "30px",
        appendDots: $('.for_slide-button'),
      },
    },
  ],
});


   $(".peak_performance_left_part.mobile").slick({
    infinite: false,
    speed: 500,
    arrows: false,
    adaptiveHeight: false,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerPadding: "40px",
  });

  // video section slider
  function initializeSwiper() {
    // Check if the screen width is <= 767px
    // Initialize Swiper
    var Swipes = new Swiper(".video-image-content", {
      loop: false,
      slidesPerView: 4,
      spaceBetween: 3,
      slidesPerGroup: 1,
      slideToClickedSlide: false,
      breakpoints: {
        991: {
          slidesPerView: 4,
          spaceBetween: 40,
          slidesPerGroup: 1,
        },
        767: {
          slidesPerView: 4,
          spaceBetween: 5,
          slidesPerGroup: 1,
        },
        320: {
          slidesPerView: 1.5,
          spaceBetween: 5,
          slidesPerGroup: 1,
        },
      },

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    });
  }

  // Initialize Swiper when the page loads

  initializeSwiper();

  // Reinitialize Swiper when the window is resized
  $(window).resize(function () {
    initializeSwiper();
    initializeSwiperV2();
  });

  $(".performance_accordion_heading").click(function () {
    $(this).parents(".peak_performance_item").toggleClass("active");
    $(this).siblings(".performance_content").slideToggle();
  });

  // video section slider
  function initializeSwiperV2() {
    // Check if the screen width is <= 767px
    // Initialize Swiper
    var Swipes = new Swiper(".video-image-content-review", {
      loop: false,
      slidesPerView: 3,
      spaceBetween: 3,
      slidesPerGroup: 1,
      slideToClickedSlide: false,
      breakpoints: {
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
        767: {
          slidesPerView: 2.5,
          spaceBetween: 5,
          slidesPerGroup: 1,
        },
        544: {
          slidesPerView: 2.5,
          spaceBetween: 5,
          slidesPerGroup: 1,
        },
        320: {
          slidesPerView: 1.5,
          spaceBetween: 10,
          slidesPerGroup: 1,
        },
      },

      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    });
  }

  // Initialize Swiper when the page loads
  initializeSwiperV2();


// Faq page js Start ================

  function handleActiveLinkBelow992() {
  const screenWidth = $(window).width();

  if (screenWidth > 992) {
    // Add 'active' class to the first link
    $(".faq-left-sidebar .js-toc .toc-list li:first-child a")
      .addClass("active");

    // Attach click event handler for links
    $(".faq-left-sidebar .js-toc .toc-list li a")
      .off("click.activeLink")
      .on("click.activeLink", function () {
        $(".faq-left-sidebar .js-toc .toc-list li a").removeClass("active");
        $(this).addClass("active");
      });
    
  } else {
    // Remove 'active' class and unbind click events for screen sizes < 992px
    $(".faq-left-sidebar .js-toc .toc-list li a")
      .removeClass("active")
      .off("click.activeLink");
  }
}

function handleDropdownForMobile() {
  const screenWidth = $(window).width();

  if (screenWidth < 992) {
    $(".js-doc-dropdown-toggle")
      .off("click.dropdown")
      .on("click.dropdown", function () {
        const $toc = $(".js-toc");
        $toc.toggleClass("active");

        $(this)
          .find("svg")
          .css("transform", $toc.hasClass("active") ? "rotate(90deg)" : "rotate(0deg)");
      });

    $(document)
      .off("click.dropdown")
      .on("click.dropdown", function (event) {
        if (!$(event.target).closest(".js-toc-container").length) {
          $(".js-toc").removeClass("active");
          $(".js-doc-dropdown-toggle svg").css("transform", "rotate(0deg)");
        }
      });

    $(".js-toc .toc-link")
      .off("click.dropdown")
      .on("click.dropdown", function () {
        const $this = $(this);
        if ($this.hasClass("selected")) return;

        const selectedItem = $this.text();
        $(".js-doc-dropdown-toggle span").html(selectedItem);
        $(".js-toc .toc-link").removeClass("selected").find(".checkmark").remove();
        $this.addClass("selected").append('<span class="checkmark">✔</span>');

        $(".js-toc").removeClass("active");
      });
    $(document)
  .off("click.tocLink")
  .on("click.tocLink", ".js-toc .toc-link", function (e) {
    e.preventDefault();

    const targetId = $(this).attr("href");
    const $target = $(targetId);

    if ($target.length) {
      const $header = $(".faq-left-sidebar");
      const headerHeight = $header.length ? $header.outerHeight() : 0;

      // Scroll offset calculation
      let scrollOffset = $("body").hasClass("template-research-page") ? 55 : 72;

      // Current scroll position fix
      let finalScrollPosition = $target.offset().top - headerHeight - scrollOffset;

      // Ensure we are not scrolling to a negative position
      finalScrollPosition = finalScrollPosition < 0 ? 0 : finalScrollPosition;

      $("html, body").stop(true, false).animate(
        {
          scrollTop: finalScrollPosition
        },
        1000
      );
    }
  });

  } else {
    $(".js-doc-dropdown-toggle").off("click.dropdown");
    $(".js-toc").removeClass("active");
  }
}

function handleScrollWithFixedHeader() {
  const screenWidth = $(window).width();
  if (screenWidth >= 992) {
  $(document)
  .off("click.tocLink")
  .on("click.tocLink", ".js-toc .toc-link", function (e) {
    e.preventDefault(); // Default behavior ko disable karna

    const targetId = $(this).attr("href");
    const $target = $(targetId);

    if ($target.length) {
      const $header = $(".shopify-section-header-sticky.sticky-header");
      const headerHeight = $header.length ? $header.outerHeight() : 0;

      // Final scroll position calculate karo
      let finalScrollPosition = $target.offset().top - headerHeight - 100;

      // Negative value ko 0 set karo
      finalScrollPosition = Math.max(finalScrollPosition, 0);

      // Smooth scroll animation
      $("html, body").stop(true, false).animate(
        {
          scrollTop: finalScrollPosition
        },
        600, // Duration
        "swing" // Smooth easing effect
      );
    }
  });
  }
}
  var elementsToWrap = $(".template-research-page .faq-left-sidebar, .template-research-page .Custom-research-section");

    // Wrap them inside a new div
    if (elementsToWrap.length) {
        elementsToWrap.wrapAll('<div class="research-combined-section"></div>');
    }
   $(".Custom-research-section:nth-child(2) .lions-mane-section .section-title").addClass("active");
 $(document).on("click", ".template-research-page .toc-list-item .toc-link", function(e) {
       e.preventDefault(); // Default anchor behavior ko rokna

        var targetID = $(this).attr("href"); // Example: #cordyceps-mushroom
        var targetSection = $(targetID); // Section ko find karna

        if (targetSection.length) {
            // Sabhi sections se 'active' class hatao
            $(".template-research-page .lions-mane-section .section-title").removeClass("active");

            // Target section me class add karo
            targetSection.addClass("active"); 
        } 
    });
  


function initializeOnResize() {
  handleDropdownForMobile();
  handleScrollWithFixedHeader();
}

// Debounce resize function
let resizeTimeout;
$(window).on("resize", function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    handleActiveLinkBelow992();
    initializeOnResize();
  }, 200); // Adjust debounce time as needed
});

// Initialize functionality
$(document).ready(function () {
  handleActiveLinkBelow992();
  initializeOnResize();
});

// Faq page js End ================
  

 // Get the checked value of the selected option
  function subOnChangeAddToCartBtnUpdate(element) {
    $('.New-Subscribe-Bundles').removeClass('active');

    // Add 'active' class to the clicked element
    $(element).addClass('active');

   // Get the name from the .selling-plan-group-name inside the active element
    var planName = $(element).find('.selling-plan-group-name').text().trim();
    
   var dataProductPrice = $(element).find(".product__sub--save").attr("data-product-price");
   if (planName === 'Subscribe & Save for LIFE') {
       
        // $(".product-form__submit .text").text("PRE-ORDER NOW");
        // $(".product-form__submit .value").text(dataProductPrice);
     
        var dataImageSave = $(element).find(".product__sub--save").attr("data-save-plan-image");
        $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("src", dataImageSave);
        $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("srcset", dataImageSave);
        $(".product__media-list .product__media-item:first-child .product__media img").attr("src", dataImageSave);
        $(".product__media-list .product__media-item:first-child .product__media img").attr("srcset", dataImageSave);
    } else if (planName === 'One-time purchase') {
        // // $(".product-form__submit .text").text("ADD TO CART");
        // $(".product-form__submit .value").text(dataProductPrice);
     
        var dataImage = $(element).find(".product__sub--save").attr("data-onetime-plan-image");
        $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("src", dataImage);
        $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("srcset", dataImage);
        $(".product__media-list .product__media-item:first-child .product__media img").attr("src", dataImage);
        $(".product__media-list .product__media-item:first-child .product__media img").attr("srcset", dataImage);

     var freeProductPrice = $(".free-trial-pack-product .product-popup-part ").attr("data-product-price");
         $(".sls-option-container .selling-plan-group-price s").text(freeProductPrice);
    } 
    
    // Get the checked value of the selected option
    var checkedValue = $(element).find("input.sls-option").val();
    var dataButton = $(element).find(".product__sub--save").attr("data-button-text");
    var dataPrice = $(element).find(".product__sub--save").attr("data-product-price");

     

    // Check if the value is 'one_time' and change the text and price accordingly
    // 1. Target a container to store last selected plan
      const $targetWrapper = $(".sealsubs-target-element");
      
      // 2. Get last selected value from data attribute
      const lastPlan = $targetWrapper.attr("data-selected-plan");
      
      // 3. Compare current value with last
      if (checkedValue !== lastPlan) {
        // Update the data attribute with the new value
        $targetWrapper.attr("data-selected-plan", checkedValue);
      
        if (checkedValue === "one_time") {
          // ONE TIME PLAN logic
          $(".new_template_design_v3 .product-free-trial-pack-button").css("display", "flex");
          $(".new_template_design_v3 .product-form__buttons button").css("display", "none");
      
          const dataImage = $(element).find(".product__sub--save").attr("data-onetime-plan-image");
      
          $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("src", dataImage);
          $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("srcset", dataImage);
          $(".product__media-list .product__media-item:first-child .product__media img").attr("src", dataImage);
          $(".product__media-list .product__media-item:first-child .product__media img").attr("srcset", dataImage);
      
          $(".new_template_design_v3 .product__media-list .product__media-item .block--product__badge.free-trial-pack").css("display", "none");
      
          setTimeout(() => {
            $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").trigger("click");
          }, 300);
      
          const freeProductPrice = $(".free-trial-pack-product .product-popup-part").attr("data-product-price");
          $(".sls-option-container .selling-plan-group-price s").text(freeProductPrice);
        } else {
          // PRE-ORDER PLAN logic
          $(".new_template_design_v3 .product-form__buttons button").css("display", "block");
          $(".new_template_design_v3 .product-free-trial-pack-button").css("display", "none");
          $(".template_free_product .product-free-trial-pack-button").css("display", "flex");
          $(".template_free_product .product-form__buttons button").css("display", "none");
      
          const dataImageSave = $(element).find(".product__sub--save").attr("data-save-plan-image");
      
          $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("src", dataImageSave);
          $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").attr("srcset", dataImageSave);
          $(".product__media-list .product__media-item:first-child .product__media img").attr("src", dataImageSave);
          $(".product__media-list .product__media-item:first-child .product__media img").attr("srcset", dataImageSave);
      
          setTimeout(() => {
            $(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img").trigger("click");
          }, 300);
      
          $(".new_template_design_v3 .product__media-list .product__media-item .block--product__badge.free-trial-pack").css("display", "block");
        }
      }
  }

  // Free Trial Pack code Start
  $(".product-free-trial-pack-button").on("click", function (event) {

      event.stopPropagation();  // Stop the event from reaching the <a> tag
      event.preventDefault();    // (optional) prevent default behavior just in case

    $("body").addClass('free-trial-pack-popup-open');
      let freeTrialPack = $(".free-trial-pack-product");

      if (freeTrialPack.length > 0) {
          // Pehle original position store karo agar already store nahi hai
          if (!freeTrialPack.data("original-parent")) {
              freeTrialPack.data("original-parent", freeTrialPack.parent());
          }

          freeTrialPack.appendTo("body");
      }
  });

  // Close icon par click hone par wapas original position par le jao
  $(document).on("click", ".title-with-close-icon .close-icon ,.free-trial-pack-product .backdrop-layar", function () {
    $("body").removeClass('free-trial-pack-popup-open');
      let freeTrialPack = $(".free-trial-pack-product");
      let originalParent = freeTrialPack.data("original-parent");

      if (originalParent) {
          freeTrialPack.appendTo(originalParent);
          freeTrialPack.removeData("original-parent"); // Data clear karna zaroori hai
      }
  });
  $(document).on("click", ".custom-free-product-ajex", function () {
  setTimeout(function () {
        $("body").removeClass('free-trial-pack-popup-open');
        $("body").removeClass('overflow-hidden');
    }, 5000);
    
    var Freeproduct =  $(this).attr('data-product-variant-id');
    var selling_planid = 690134516052; // free trial pack
    var quantity = 1
    addToCartJS(Freeproduct, quantity, selling_planid);
  });

 function addToCartJS(Freeproduct, quantity, SellingtId) {
  // Step 1: Check if item is already in cart
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const alreadyExists = cart.items.some(item => item.variant_id == Freeproduct);

      if (alreadyExists) {
        // Item already in cart, just redirect if needed
        if (!document.querySelector('.new-collection-btn')) {
          window.location.href = '/checkout';
        }
        return;
      }

      // Step 2: Proceed to add only if not already in cart
      const cartDrawer = document.querySelector('cart-drawer');
      const sectionsToRender = cartDrawer?.getSectionsToRender?.().map(section => section.id) || [];
      const sections_url = window.location.pathname;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          quantity: quantity,
          id: Freeproduct,
          selling_plan: SellingtId,
          sections: sectionsToRender,
          sections_url: sections_url
        })
      })
        .then(response => response.json())
        .then(response => {
          if (document.querySelector('.new-collection-btn')) {
            cartDrawer.renderContents(response);
            cartDrawer.open();
            if (cartDrawer.classList.contains('is-empty')) {
              cartDrawer.classList.remove('is-empty');
            }
          } else {
            window.location.href = '/checkout';
          }
        })
        .catch(error => {
          console.error("Error adding item to cart:", error);
        });
    });
}




  // Free Trial Pack code end
  
  $(".product-save-with-info").show();
  window.onload = function () {
    var counter = 0;
    var interval = setInterval(function () {
      counter++;
      if ($(".sealsubs-target-element").length > 0) {

        // Select the label element and color change 
        const label = $(".sls-purchase-options-container .seal-table:nth-of-type(1)").find(".sls-selling-plan-group-name");

          if (label.length > 0) {
            const updatedText = label.html().replace(
              "Save for LIFE",
              '<p style="color: #01685b;">Save for LIFE</p>'
            );
            // Update the label with the new HTML
            label.html(updatedText);
          }
       if (!$("body").hasClass("template_free_product")) {
               // Free Trial Pack defolt active 
              $(".new_template_design_v3 .sls-option-container.sls-active").removeClass("sls-active");
              $(".new_template_design_v3 .sls-option-container input[value='one_time']").prop("checked", true).closest(".sls-option-container").addClass("sls-active");
              $(".new_template_design_v3 .sls-option-container input[data-type='subscription']").prop("checked", false);
       }
        var subGiftHtml;
        var subGiftHtmlInfo;
        // $(".sls-selling-plan-group-price .sls-price .money").html("£39.99");
        if ($("body").hasClass("new_template_design") && !$("body").hasClass("template_free_product")) {
          $(`body`).attr("data-scroll-to-top", "false");
          subGiftHtml = $(".save-bundle-plan .product__sub--save").clone();
          subGiftHtmlOne = $(".one-time-plan .product__sub--save").clone();
          var totlePricelabel = $(".save-bundle-plan .save-more-content .selling-plan-group-price .price_original").clone();
          $(".sls-purchase-options-container .seal-col-radio[data-selling-plan-group-option-radio] + .sls-label-container .sls-selling-plan-group-first-line .sls-total-price").before(totlePricelabel);

          // onetime purchase  to convert Free Trial Pack trigger click
          var subGiftHtmlPrice = $(".new_template_design_v3 .one-time-plan .save-more-content").clone();
          $(".new_template_design_v3 .sls-purchase-options-container .seal-col-radio[data-one-time-option-radio] + .sls-label-container .sls-selling-plan-group-first-line").hide();
          $(".new_template_design_v3 .sls-purchase-options-container .seal-col-radio[data-one-time-option-radio] + .sls-label-container .sls-selling-plan-group-first-line").before(subGiftHtmlPrice);
          
          $(".sls-purchase-options-container .seal-col-radio[data-selling-plan-group-option-radio] + .sls-label-container .sls-selling-plan-group-first-line").after(subGiftHtml);
          $(".sls-purchase-options-container .seal-col-radio[data-one-time-option-radio] + .sls-label-container .sls-selling-plan-group-first-line").after(subGiftHtmlOne);
        } else {
          subGiftHtml = $(".save-bundle-plan .product__sub--save").clone();
          subGiftHtmlInfo = $(".product__sub--save--info").clone();
          $(".sls-purchase-options-container .seal-col-radio[data-selling-plan-group-option-radio] + .sls-label-container .sls-selling-plan-group-first-line").after(subGiftHtml);
          $(".sls-purchase-options-container .seal-col-radio[data-selling-plan-group-option-radio] + .sls-label-container").after(subGiftHtmlInfo);
        }
      // free product code 
        if ($("body").hasClass("template_free_product")) {
          subGiftHtmlOne = $(".one-time-plan .product__sub--save").clone();

           $(".sls-purchase-options-container .seal-col-radio[data-one-time-option-radio] + .sls-label-container .sls-selling-plan-group-first-line").after(subGiftHtmlOne);
          
          var totlePricelabel = $(".product-save-with-info.one-time-plan .save-more-content .selling-plan-group-price").clone();
          $(".sls-purchase-options-container .seal-col-radio[data-selling-plan-group-option-radio] + .sls-label-container .sls-selling-plan-group-first-line .sls-total-price").before(totlePricelabel);
          
        }
      
        $(".product-save-with-info").hide();
        $(".product-form__submit").prop("disabled", false);
        subOnChangeAddToCartBtnUpdate();
        $(".template--product .sealsubs-target-element").attr("style","display: block !important");

        // onetime purchase trigger click
        if (!$("body").hasClass("template_free_product")) {
            var oneTimePurchase = $(".new_template_design_v3 .sls-option-container:last-child");
            oneTimePurchase.trigger("click");
          }
         $(`body`).attr("data-scroll-to-top", "true");

        clearInterval(interval);
      }
      if (counter > 10) {
        clearInterval(interval);
      }
    }, 1000);
  };

  $(document).on("click", ".sls-option-container , .New-Subscribe-Bundles", function () {
    subOnChangeAddToCartBtnUpdate($(this));
  });

  // selling Plan description Show hide Start

 $(document).on("click", ".selling_plan--desc span, .product__sub--save--info .selling_plan--desc span", function (e) {
  e.stopPropagation(); // Prevent event propagation
  $(".selling-description").toggleClass("active"); // Add 'active' class to the target element
});

  $(document).click(function () {
    $(".selling-description").removeClass("active");
  });

  $(".selling-description").click(function (e) {
    e.stopPropagation();
  });

  $(document).on("click", ".limited_stock_content .limited--desc svg, .limited_stock_content .limited--desc p strong", function (e) {
  e.stopPropagation(); // Prevent event propagation
  $(".limited_stock_content .limited-description").toggleClass("active"); // Add 'active' class to the target element
});

  $(document).click(function () {
    $(".limited_stock_content .limited-description").removeClass("active");
  });

  $(".limited_stock_content .limited-description").click(function (e) {
    e.stopPropagation();
  });
  // selling Plan description Show hide  End

  // FAQs page js Start

  if (typeof tocbot !== 'undefined') {
    tocbot.init();
    tocbot.init({
      // Where to render the table of contents.
      tocSelector: ".js-toc",
      // Where to grab the headings to build the table of contents.
      contentSelector: ".template-faqs .content-for-layout , .template-research-page .content-for-layout",
      // Which headings to grab inside of the contentSelector element.
      headingSelector: "h6, h2",
      collapseDepth: 0,
      isCollapsedClass: "is-collapsed",
      collapsibleClass: "is-collapsible",
    });
  }



  // Adjust scrolling behavior for fixed header
  $(document).on("click", ".js-toc .toc-link", function () {
    const targetId = $(this).attr("href"); // Get the target ID from href
    const $header = $(".shopify-section-header-sticky sticky-header");
    const headerHeight = $header.length ? $header.outerHeight() : 0;
    console.log("headerHeight ", headerHeight);
    if ($(targetId).length) {
      // Scroll to the target position with an offset for the header height
      $("html, body").animate(
        {
          scrollTop: $(targetId).offset().top - headerHeight - 100,
        },
        600 // Adjust the duration for smooth scrolling
      );
    }
  });
  // FAQs page js End

  // scroll top js Start
function isElementInViewport($element) {
  if (!$element.length) return false; // Ensure element exists

  var rect = $element[0].getBoundingClientRect();
  return rect.top >= 0 && rect.bottom <= window.innerHeight;
}

function Thumbnailscroll(clickedElement) {
  var slider = $("slider-component"); // Correct selector
  var headerHeight = 0; // Adjust if needed

  if (slider.length && $(window).width() < 543) {
    var sliderTop = slider.offset().top - headerHeight;

    setTimeout(function () {
      $("html, body").animate({ scrollTop: sliderTop }, 1000);
    }, 450);

   
  }
}

// Scroll only if `.sls-purchase-options-container` is in viewport
$(document).on("click", ".sls-option-container.seal-table", function (event) {
  var $purchaseContainer = $(".sls-option-container");

  if (isElementInViewport($purchaseContainer)) {
    event.preventDefault(); // Prevent default behavior
    var flag = $("body").attr("data-scroll-to-top");

    if (flag == "true") {
      if (!$(this).hasClass('Scrolled')) {
        Thumbnailscroll(this);  // Pass clicked element
        $(this).addClass('Scrolled');
      }
    }
  }
});


  // scroll top js end

// Review Click event Start
// Scroll to `.video-section-slider` when `.custom_review_content` is clicked
$(document).on("click", ".new_template_design_v3 .custom_review_content .review_content", function () {
  var $videoSection = $(".new_template_design_v3 .video-section-slider .video-wrapper");

  if ($videoSection.length) {
    var targetOffset = $videoSection.offset().top - 10; // Adjust offset if needed

    $("html, body").stop().animate(
      { scrollTop: targetOffset },
      800, // Smooth scrolling speed
      "swing" // Smooth animation effect
    );
  }
});

// Review Click event End
  
  
  
$(document).on("click", ".cart-redirection-checkout .cart-drawer__overlay", function () {
    $('cart-drawer').attr('style', 'display: none !important');
});
  $(document).on("click", ".cart-redirection-checkout .header__icon--cart", function () {
    $('cart-drawer').attr('style', 'display: flex !important');
});



// Main PDP New Design ***************************
     function adjustThumbnailHeight() {
       if ($(window).width() > 1200) { // Only run if the screen width is greater than 1200px
        var mainImageHeight = $(".product-media-slider-gallery slider-component ul li .product__media").outerHeight();
        $(".product-media-slider-gallery .product-icon-with__text").css("height", mainImageHeight);
    } else {
        // Reset height when screen is 767px or less
        $(".product-media-slider-gallery .product-icon-with__text").css("height", ""); 
    }
    }
   // Run on load
       adjustThumbnailHeight();
    
    // Adjust height on window resize
    $(window).on("resize", function () {
        adjustThumbnailHeight();
      
    });

 // Size chart popup
      $(document).on("click",".information-popup",function() {
        $(this).closest('body').toggleClass('popup-open');
      });

      $(document).on("click",".nutrition-popup-trigger",function() {
  $('body').toggleClass('popup-open');
});

       $(document).on("click","#Details-menu-drawer-container",function() {
        $(this).closest('body').toggleClass('menu-drawer-open');
      });

      //Popup Close Event
      $(document).on("click",".popup-close-event",function() {
        $(this).closest('body').removeClass('popup-open');
      });


  // video and review section combined
  $(document).on("click", ".Load-more-reviews-buttton .button_box", function () {
     $('.load-more-reviews-option').toggleClass('open-review');
     $('.Load-more-reviews-buttton').toggleClass('add-pading');
  });


 
  
});


$(document).ready(function () {
  function handleMobileScript() {
    if ($(window).width() > 768) {
      // If the screen is larger than 1024px (desktop), remove event listeners and reset styles
      $(window).off("scroll");
      $(".new_template_design_v3 .menu-link").off("click");
      $(".new_template_design_v3 .navigation_item_scrolltop").off("click");
      $(".new_template_design_v3 header").css("display", "grid");
      $(".new_template_design_v3 .image_with_banner_scroll_navigation").removeClass("scroll");
      return;
    }

    var $navigationElements = $(".new_template_design_v3 .image_with_banner_scroll_navigation");
    var $header = $(".new_template_design_v3 header");
    var $buyButton = $(".new_template_design_v3 .information-popup");
    var $scrollTopButton = $(".new_template_design_v3 .navigation_item_scrolltop");
    var headerHeight = $header.outerHeight() || 64;

    if (!$navigationElements.length || !$header.length || !$buyButton.length || !$scrollTopButton.length) {
      return;
    }

    var isThrottled = false;

    function isElementOutOfViewport($element) {
      var rect = $element[0].getBoundingClientRect();
      return rect.bottom <= headerHeight;
    }

    function handleScroll() {
      if (isElementOutOfViewport($buyButton)) {
        $navigationElements.addClass("scroll");
        $header.hide();
      } else {
        $navigationElements.removeClass("scroll");
        $header.css("display", "grid");
      }
    }

    $(window).on("scroll", function () {
      if (!isThrottled) {
        handleScroll();
        isThrottled = true;
        setTimeout(function () {
          isThrottled = false;
        }, 200);
      }
    });

    // Scroll top button click event
    $scrollTopButton.on("click", function () {
      $("html, body").animate({ scrollTop: 0 }, 200, "swing", function () {
        $navigationElements.removeClass("scroll");
        $header.css("display", "grid");
      });
    });

    $(document).on("click", ".new_template_design_v3 .menu-link", function (e) {
  e.preventDefault();
  var sectionId = $(this).attr("href");
  var $section = $(sectionId);
  var navHeight = $navigationElements.outerHeight() || 10;
  var extraOffset = 30;

  if ($section.length) {
    var targetOffset = $section.offset().top - navHeight - extraOffset;

    // Small delay to let iOS calculate layout correctly
    setTimeout(function () {
      $("html, body").stop().animate(
        { scrollTop: targetOffset },
        400,
        "swing"
      );
    }, 100); // You can increase to 100 if needed

    $(".new_template_design_v3 .menu-link").removeClass("link_active");
    $(this).addClass("link_active");
  }
});

  }

  // Run the function on page load and when resizing the window
  handleMobileScript();
  $(window).resize(handleMobileScript);
});


document.addEventListener("DOMContentLoaded", function() {
      let policyContainer = document.querySelector(".shopify-policy__container");
      if (policyContainer) {
          // Parent div create karo
          let wrapperDiv = document.createElement("div");
          wrapperDiv.classList.add("policy-wrapper"); // New wrapper class

          // policyContainer ko wrapper ke andar move karo
          policyContainer.parentNode.insertBefore(wrapperDiv, policyContainer);
          wrapperDiv.appendChild(policyContainer);
      }
  });

$(document).on("click", ".navigation a", function (e) {
  e.preventDefault(); // Prevent default anchor behavior
  const targetId = $(this).attr("href"); // Get the target ID from href
  const $header = $(".shopify-section-header-sticky sticky-header");
  const headerHeight = $header.length ? $header.outerHeight() : 0;

  // Define custom offsets for desktop
  const desktopOffsets = {
    "#from-our-founder": 70,
    "#how-to-brew": 5,
    "#what-to-expect": 90,
    "#Recipes": 120,
    "#faq-section": 70
  };

  // Define custom offsets for screen width 543px or smaller
  const mobileOffsets = {
    "#from-our-founder": 50,
    "#how-to-brew": 10,
    "#what-to-expect": 70,
    "#Recipes": 100,
    "#faq-section": 60
  };

  // Check screen width and select the appropriate offset map
  const isMobile = window.innerWidth <= 543;
  const offsetMap = isMobile ? mobileOffsets : desktopOffsets;

  // Get custom offset or default to 70
  const customOffset = offsetMap[targetId] || 70;

  if ($(targetId).length) {
    // Scroll to the target position with the adjusted offset
    $("html, body").animate(
      {
        scrollTop: $(targetId).offset().top - customOffset,
      },
      600 // Smooth scrolling duration
    );
  }
});


$(document).ready(function () {
  $(".filter-button").on("click", function (event) {
    event.preventDefault();
    event.stopPropagation();
    $(".filter-options").toggle();
  });

  let itemsToShow = 12;
  let reviews = $(".review-item");
  let totalReviews = reviews.length;
  let loadMoreBtn = $("#load-more");
  let itemToVisible = itemsToShow;

  function showLimitedReviews() {
    $(".review-item").hide().slice(0, itemToVisible).fadeIn();
    toggleLoadMoreButton();
  }

  function toggleLoadMoreButton() {
    if ($(".review-item:visible").length === totalReviews) {
      loadMoreBtn.hide();
    } else {
      loadMoreBtn.show();
    }
  }

  function showItems(count) {
    console.log("itemToVisible:", count);
  }

  showLimitedReviews();

  loadMoreBtn.on("click", function () {
    let visibleReviews = $(".review-item:visible").length;
    itemToVisible = visibleReviews + itemsToShow;

    $(".review-item").slice(visibleReviews, itemToVisible).fadeIn();
    toggleLoadMoreButton();
    
    showItems(itemToVisible);
  });

  $(".filter-options button").on("click", function (event) {
    event.preventDefault();
    event.stopPropagation();

    let filter = $(this).data("filter");
    let sortedReviews = $(".review-item").get();
    if (filter === "highest") {
      sortedReviews.sort((a, b) => $(b).data("rating") - $(a).data("rating"));
    } else if (filter === "lowest") {
      sortedReviews.sort((a, b) => $(a).data("rating") - $(b).data("rating"));
    } else if (filter === "featured") {
      sortedReviews.sort((a, b) => {
        let dateA = parseDate($(a).attr("data-date"));
        let dateB = parseDate($(b).attr("data-date"));
        return dateB - dateA;
      });
    }

    $(".reviews-container").empty().append(sortedReviews);

    $(".review-item").hide().slice(0, itemToVisible).fadeIn();
    toggleLoadMoreButton();
    showItems(itemToVisible);

    $(".filter-options button").removeClass("active");
    $(this).addClass("active");

    // ✅ Update selected icons
    $(".selected-icon").hide();
    $(this).find(".selected-icon").html('<svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.364 9.28895L15.556 0.0959473L16.971 1.50995L6.364 12.1169L0 5.75295L1.414 4.33895L6.364 9.28895Z" fill="black"></path></svg>').show();
  });

  function parseDate(dateStr) {
    dateStr = dateStr.replace("Since ", "").trim();
    let date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      date = new Date(`${dateStr} 1`);
    }
    return date;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  let menuItems = document.querySelectorAll(".menu-drawer__menu-item");

  menuItems.forEach((item) => {
    item.addEventListener("click", function () {
      let submenu = this.nextElementSibling; // Get the submenu
      let svgIcon = this.querySelector(".svg-wrapper svg"); // Get the SVG inside the clicked item

      if (submenu && submenu.classList.contains("menu-drawer__submenu")) {
        // Toggle the display
        if (submenu.style.display === "block" || submenu.style.display === "") {
          submenu.style.display = "none";
          svgIcon.style.transform = "rotate(0deg)"; // Reset rotation
        } else {
          submenu.style.display = "block";
          svgIcon.style.transform = "rotate(180deg)"; // Rotate 180°
        }
      }
    });
  });
});


// variant base on change event for black friday offer
function updateImages(imgSrc) {
  // Thumbnail first image
  const thumbImg = document.querySelector(".thumbnail-slider .thumbnail-list__item:first-child .thumbnail img");
  if (thumbImg) {
    thumbImg.src = imgSrc;
    thumbImg.srcset = imgSrc;
  }
  // Main product media first image
  const mainImg = document.querySelector(".product__media-list .product__media-item:first-child .product__media img");
  if (mainImg) {
      mainImg.src = imgSrc;
      mainImg.srcset = imgSrc;
  }
}
document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll('.serve-group').forEach(group => {

    const radios = group.querySelectorAll('.hidden-radio');
    const buttonAtc = document.querySelector('.product-form__submit .value');

    radios.forEach(radio => {
      radio.addEventListener("change", function () {
        
        // remove active from all .option-inner in this serve-group
        group.querySelectorAll('.option-inner').forEach(inner => {
          inner.classList.remove("active");
        });

        // FREE PRODUCT LOGIC
        const freeInput = group.querySelector('.free_product_input');
        
        // find this radio's label
        const label = group.querySelector(`label[for="${this.id}"]`);

        if (label) {
          const optionBox = label.querySelector(".option-inner");
          console.log(optionBox,"optionBox--");
          
          if (optionBox) {
            optionBox.classList.add("active");

            const Btntext = optionBox.dataset.buttonPrice;
            console.log('Btntext',Btntext);
            buttonAtc.innerHTML = Btntext;

            if (optionBox.classList.contains('subscribe_main')) {
                // freeInput.disabled = false;
                const dataImageSave = optionBox.dataset.savePlanImage;
                updateImages(dataImageSave);

            } else if (optionBox.classList.contains('one-time-purchase-main')) {
                // freeInput.disabled = true;
                const dataImage = optionBox.dataset.onetimePlanImage;
                updateImages(dataImage);
            }

          }
        }

        
      });
    });

  });

  // on load disaled the free product if no selling plan selected
  // const params = new URLSearchParams(window.location.search);
  // const variantID = params.get("variant");
  // const sellingPlanID = params.get("selling_plan");
  // // console.log('sellingPlanID',sellingPlanID);

  // if (document.querySelectorAll(".cart-redirection-checkout").length > 0) {
  //   const disabledFree =  document.querySelectorAll(".free_product_input");
  //   if (!sellingPlanID) {
  //     disabledFree.forEach(input => {
  //       input.disabled = true;
  //     });
  //     // console.log("disabledFree-----oneeeeeeeeeee---on load");
  //   }
  //   else {
  //     disabledFree.forEach(input => {
  //       input.disabled = false;
  //     });
  //     // console.log("enabledFree-----oneeeeeeeeeee---on load");
  //   }
  // }

  // becuse we use skio app disble all free inputs
  // const disabledFree =  document.querySelectorAll(".free_product_input");
  // disabledFree.forEach(input => {
  //   input.disabled = true;
  // });

  if(document.body.classList.contains('main-black-friday')) {

  
    const params = new URLSearchParams(window.location.search);
    const variantID = params.get("variant");
    const sellingPlanID = params.get("selling_plan");
    const customQty = $(".custom-qty");

    if (!sellingPlanID) {
      if(document.querySelector(".thirty-servings") != null){
        document.querySelector(".thirty-servings").disabled = false;
        
      }
      if(document.querySelector(".default-input") != null){
        document.querySelector(".default-input").disabled = true;
      }
        // on variant change - change qty
        console.log("customQty",customQty);   

        if(variantID != null) {
          console.log("variantID-",variantID);   
          if(variantID == '52978592383316') {
            console.log("60--------load");   
            customQty.val('2');
          }
          else if(variantID == '52978592350548') {
            console.log("30--------load");   
            customQty.val('1');
          }
        }
    }
    else {
      if(document.querySelector(".thirty-servings") != null){
        document.querySelector(".thirty-servings").disabled = true;
      }
      if(document.querySelector(".default-input") != null){
        document.querySelector(".default-input").disabled = false;
      }
      customQty.val('1');
    }

  }
  if (document.body.classList.contains('main-black-friday')) {
      // location.reload();
  }
    
});

// window.addEventListener("pageshow", function (event) {

//     let isBack = event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward";

//     if (isBack && document.body.classList.contains("template--product")) {

//         let lastReload = sessionStorage.getItem("productReloadTimestamp");
//         let now = Date.now();

//         // If first time or last reload timestamp is too old (1 sec difference prevents looping)
//         if (!lastReload || now - lastReload > 1000) {
//             console.log("🔄 Back to product — reloading...");

//             // Store timestamp BEFORE reload
//             sessionStorage.setItem("productReloadTimestamp", now);

//             location.reload();
//         }
//     }
// });

// document.addEventListener("DOMContentLoaded", function(){
//     if (!document.body.classList.contains("template--product")) {
//         sessionStorage.removeItem("productReloadTimestamp");
//     }
// })




